/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated/activity'
import { Route as AuthenticatedCatalogCollectionsRouteImport } from './routes/_authenticated/catalog/collections'
import { Route as AuthenticatedCatalogMediaRouteImport } from './routes/_authenticated/catalog/media'
import { Route as AuthenticatedCatalogProductsRouteImport } from './routes/_authenticated/catalog/products'
import { Route as AuthenticatedCatalogVocabularyRouteImport } from './routes/_authenticated/catalog/vocabulary'
import { Route as AuthenticatedConfigurationSettingsRouteImport } from './routes/_authenticated/configuration/settings'
import { Route as AuthenticatedConfigurationRegistriesCountriesRouteImport } from './routes/_authenticated/configuration/registries/countries'
import { Route as AuthenticatedConfigurationRegistriesCurrenciesRouteImport } from './routes/_authenticated/configuration/registries/currencies'
import { Route as AuthenticatedConfigurationRegistriesLocalesRouteImport } from './routes/_authenticated/configuration/registries/locales'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCatalogCollectionsRoute =
  AuthenticatedCatalogCollectionsRouteImport.update({
    id: '/catalog/collections',
    path: '/catalog/collections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogMediaRoute =
  AuthenticatedCatalogMediaRouteImport.update({
    id: '/catalog/media',
    path: '/catalog/media',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogProductsRoute =
  AuthenticatedCatalogProductsRouteImport.update({
    id: '/catalog/products',
    path: '/catalog/products',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogVocabularyRoute =
  AuthenticatedCatalogVocabularyRouteImport.update({
    id: '/catalog/vocabulary',
    path: '/catalog/vocabulary',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfigurationSettingsRoute =
  AuthenticatedConfigurationSettingsRouteImport.update({
    id: '/configuration/settings',
    path: '/configuration/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfigurationRegistriesCountriesRoute =
  AuthenticatedConfigurationRegistriesCountriesRouteImport.update({
    id: '/configuration/registries/countries',
    path: '/configuration/registries/countries',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfigurationRegistriesCurrenciesRoute =
  AuthenticatedConfigurationRegistriesCurrenciesRouteImport.update({
    id: '/configuration/registries/currencies',
    path: '/configuration/registries/currencies',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfigurationRegistriesLocalesRoute =
  AuthenticatedConfigurationRegistriesLocalesRouteImport.update({
    id: '/configuration/registries/locales',
    path: '/configuration/registries/locales',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sign-in': typeof SignInRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/catalog/collections': typeof AuthenticatedCatalogCollectionsRoute
  '/catalog/media': typeof AuthenticatedCatalogMediaRoute
  '/catalog/products': typeof AuthenticatedCatalogProductsRoute
  '/catalog/vocabulary': typeof AuthenticatedCatalogVocabularyRoute
  '/configuration/settings': typeof AuthenticatedConfigurationSettingsRoute
  '/configuration/registries/countries': typeof AuthenticatedConfigurationRegistriesCountriesRoute
  '/configuration/registries/currencies': typeof AuthenticatedConfigurationRegistriesCurrenciesRoute
  '/configuration/registries/locales': typeof AuthenticatedConfigurationRegistriesLocalesRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/': typeof AuthenticatedIndexRoute
  '/catalog/collections': typeof AuthenticatedCatalogCollectionsRoute
  '/catalog/media': typeof AuthenticatedCatalogMediaRoute
  '/catalog/products': typeof AuthenticatedCatalogProductsRoute
  '/catalog/vocabulary': typeof AuthenticatedCatalogVocabularyRoute
  '/configuration/settings': typeof AuthenticatedConfigurationSettingsRoute
  '/configuration/registries/countries': typeof AuthenticatedConfigurationRegistriesCountriesRoute
  '/configuration/registries/currencies': typeof AuthenticatedConfigurationRegistriesCurrenciesRoute
  '/configuration/registries/locales': typeof AuthenticatedConfigurationRegistriesLocalesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authenticated/activity': typeof AuthenticatedActivityRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/catalog/collections': typeof AuthenticatedCatalogCollectionsRoute
  '/_authenticated/catalog/media': typeof AuthenticatedCatalogMediaRoute
  '/_authenticated/catalog/products': typeof AuthenticatedCatalogProductsRoute
  '/_authenticated/catalog/vocabulary': typeof AuthenticatedCatalogVocabularyRoute
  '/_authenticated/configuration/settings': typeof AuthenticatedConfigurationSettingsRoute
  '/_authenticated/configuration/registries/countries': typeof AuthenticatedConfigurationRegistriesCountriesRoute
  '/_authenticated/configuration/registries/currencies': typeof AuthenticatedConfigurationRegistriesCurrenciesRoute
  '/_authenticated/configuration/registries/locales': typeof AuthenticatedConfigurationRegistriesLocalesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/activity'
    | '/catalog/collections'
    | '/catalog/media'
    | '/catalog/products'
    | '/catalog/vocabulary'
    | '/configuration/settings'
    | '/configuration/registries/countries'
    | '/configuration/registries/currencies'
    | '/configuration/registries/locales'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/activity'
    | '/'
    | '/catalog/collections'
    | '/catalog/media'
    | '/catalog/products'
    | '/catalog/vocabulary'
    | '/configuration/settings'
    | '/configuration/registries/countries'
    | '/configuration/registries/currencies'
    | '/configuration/registries/locales'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign-in'
    | '/_authenticated/activity'
    | '/_authenticated/'
    | '/_authenticated/catalog/collections'
    | '/_authenticated/catalog/media'
    | '/_authenticated/catalog/products'
    | '/_authenticated/catalog/vocabulary'
    | '/_authenticated/configuration/settings'
    | '/_authenticated/configuration/registries/countries'
    | '/_authenticated/configuration/registries/currencies'
    | '/_authenticated/configuration/registries/locales'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog/collections': {
      id: '/_authenticated/catalog/collections'
      path: '/catalog/collections'
      fullPath: '/catalog/collections'
      preLoaderRoute: typeof AuthenticatedCatalogCollectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog/media': {
      id: '/_authenticated/catalog/media'
      path: '/catalog/media'
      fullPath: '/catalog/media'
      preLoaderRoute: typeof AuthenticatedCatalogMediaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog/products': {
      id: '/_authenticated/catalog/products'
      path: '/catalog/products'
      fullPath: '/catalog/products'
      preLoaderRoute: typeof AuthenticatedCatalogProductsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog/vocabulary': {
      id: '/_authenticated/catalog/vocabulary'
      path: '/catalog/vocabulary'
      fullPath: '/catalog/vocabulary'
      preLoaderRoute: typeof AuthenticatedCatalogVocabularyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuration/settings': {
      id: '/_authenticated/configuration/settings'
      path: '/configuration/settings'
      fullPath: '/configuration/settings'
      preLoaderRoute: typeof AuthenticatedConfigurationSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuration/registries/countries': {
      id: '/_authenticated/configuration/registries/countries'
      path: '/configuration/registries/countries'
      fullPath: '/configuration/registries/countries'
      preLoaderRoute: typeof AuthenticatedConfigurationRegistriesCountriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuration/registries/currencies': {
      id: '/_authenticated/configuration/registries/currencies'
      path: '/configuration/registries/currencies'
      fullPath: '/configuration/registries/currencies'
      preLoaderRoute: typeof AuthenticatedConfigurationRegistriesCurrenciesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuration/registries/locales': {
      id: '/_authenticated/configuration/registries/locales'
      path: '/configuration/registries/locales'
      fullPath: '/configuration/registries/locales'
      preLoaderRoute: typeof AuthenticatedConfigurationRegistriesLocalesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedActivityRoute: typeof AuthenticatedActivityRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCatalogCollectionsRoute: typeof AuthenticatedCatalogCollectionsRoute
  AuthenticatedCatalogMediaRoute: typeof AuthenticatedCatalogMediaRoute
  AuthenticatedCatalogProductsRoute: typeof AuthenticatedCatalogProductsRoute
  AuthenticatedCatalogVocabularyRoute: typeof AuthenticatedCatalogVocabularyRoute
  AuthenticatedConfigurationSettingsRoute: typeof AuthenticatedConfigurationSettingsRoute
  AuthenticatedConfigurationRegistriesCountriesRoute: typeof AuthenticatedConfigurationRegistriesCountriesRoute
  AuthenticatedConfigurationRegistriesCurrenciesRoute: typeof AuthenticatedConfigurationRegistriesCurrenciesRoute
  AuthenticatedConfigurationRegistriesLocalesRoute: typeof AuthenticatedConfigurationRegistriesLocalesRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCatalogCollectionsRoute: AuthenticatedCatalogCollectionsRoute,
  AuthenticatedCatalogMediaRoute: AuthenticatedCatalogMediaRoute,
  AuthenticatedCatalogProductsRoute: AuthenticatedCatalogProductsRoute,
  AuthenticatedCatalogVocabularyRoute: AuthenticatedCatalogVocabularyRoute,
  AuthenticatedConfigurationSettingsRoute:
    AuthenticatedConfigurationSettingsRoute,
  AuthenticatedConfigurationRegistriesCountriesRoute:
    AuthenticatedConfigurationRegistriesCountriesRoute,
  AuthenticatedConfigurationRegistriesCurrenciesRoute:
    AuthenticatedConfigurationRegistriesCurrenciesRoute,
  AuthenticatedConfigurationRegistriesLocalesRoute:
    AuthenticatedConfigurationRegistriesLocalesRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
